module.exports = __webpack_public_path__ + "img/pocoll.288139ad.png";